import React from 'react';
import {
    AppBar,
    Box,
    Button,
    Chip,
    IconButton,
    Toolbar,
    Typography
} from '@mui/material';
import {
    Logout as LogoutIcon,
    Menu as MenuIcon
} from '@mui/icons-material';

function PortalHeader({
    currentUser,
    isActualAdmin,
    isAgentViewMode,
    onToggleMobileNavigation,
    onSwitchAdminViewMode,
    onLogout
}) {
    return (
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar>
                <IconButton
                    color="inherit"
                    edge="start"
                    onClick={onToggleMobileNavigation}
                    sx={{ mr: 2, display: { sm: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                    Agents Sales Portal
                </Typography>
                <Box sx={{ mr: 2, display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 1 }}>
                    <Typography variant="body1">
                        Welcome, {currentUser?.name}
                    </Typography>
                    {isActualAdmin && (
                        <>
                            <Chip
                                label={isAgentViewMode ? 'Agent View Mode' : 'Admin View'}
                                color={isAgentViewMode ? 'info' : 'warning'}
                                size="small"
                                sx={{ color: 'white', fontWeight: 700 }}
                            />
                            <Button
                                color="inherit"
                                variant="outlined"
                                size="small"
                                onClick={() => onSwitchAdminViewMode(isAgentViewMode ? 'admin' : 'agent')}
                                sx={{ borderColor: 'rgba(255,255,255,0.7)', color: 'white' }}
                            >
                                {isAgentViewMode ? 'Switch to Admin View' : 'Switch to Agent View'}
                            </Button>
                            {isAgentViewMode && (
                                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.85)', maxWidth: 210 }}>
                                    View-only role mode. No impersonation.
                                </Typography>
                            )}
                        </>
                    )}
                </Box>
                <Button
                    color="inherit"
                    onClick={onLogout}
                    startIcon={<LogoutIcon />}
                    sx={{ display: { xs: 'none', sm: 'flex' } }}
                >
                    Logout
                </Button>
                <IconButton color="inherit" onClick={onLogout} sx={{ display: { xs: 'flex', sm: 'none' } }}>
                    <LogoutIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
}

export default PortalHeader;
